import { api } from './client'

// Fitbit (via the Google Health API) OAuth start. Returns
// { authorize_url }; the browser goes there, and the backend callback
// sends it back to /profile?fitbit=connected|error. There is no native
// (haiven://) return path for Fitbit, unlike Oura.
export const fitbitApi = {
  authorize: (token) => api.get('/fitbit/authorize', token),
}
